const TestRequestWrapper = () => import('./TestRequestWrapper')

export default function install(Vue) {
  Vue.component('TestRequestWrapper', TestRequestWrapper)
}
